import Vue from 'vue'
import Vuex from 'vuex'
import loading from './modules/loading'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    loading
  },
  state: {
    isLoggedIn: false,
    siteInfo: null,
    bannerList: [],
    runtimeJackpot: null
  },
  mutations: {
    SET_LOGGED_IN (state, value) {
      state.isLoggedIn = value
    },
    SET_SITE_INFO (state, info) {
      state.siteInfo = info
    },
    SET_BANNER_LIST (state, list) {
      state.bannerList = Array.isArray(list) ? list : []
    },
    SET_RUNTIME_JACKPOT (state, value) {
      state.runtimeJackpot = value
    }
  }
})
